import React from 'react';
import { partial } from 'lodash';
import { InputItem } from '../../Forms/InputItem';
import { SwitchItem } from '../../Forms/SwitchItem';
import { getTranslationKey } from '../../../modules/utils';
import { SalesCouponSelection } from '../SalesCouponSelection';
import { IShopSalesAutomation } from '../../../modules/types';
import { InlineForm, SmallInputWrapper } from './styles';
import { SWITCH_DIRECTION } from './constants';

interface IProps {
  anniversaryCouponCodeAdvertising: IShopSalesAutomation['anniversaryCouponCodeAdvertising'];
  isFormDisabled: boolean;
  updateFormValue: (path: string, value: unknown) => void;
}

export const AnniversaryCouponSection = React.memo(
  ({ anniversaryCouponCodeAdvertising, isFormDisabled, updateFormValue }: IProps) => (
    <>
      <SwitchItem
        value={anniversaryCouponCodeAdvertising?.enabled}
        isDisabled={isFormDisabled}
        changeCallback={partial(updateFormValue, 'anniversaryCouponCodeAdvertising.enabled')}
        label={getTranslationKey('collectionShop.anniversaryCouponToggleLabel')}
        direction={SWITCH_DIRECTION}
        margin="15px 0 5px 0"
        id="anniversaryCouponCodeAdvertising-switch"
        withTooltip
        tooltipText={getTranslationKey('learnMoreHintAnniversary')}
        isIconTooltip
      />
      <InlineForm offsetLeft>
        <SalesCouponSelection
          isDisabled={isFormDisabled}
          value={String(anniversaryCouponCodeAdvertising?.couponId)}
          changeCallback={partial(updateFormValue, 'anniversaryCouponCodeAdvertising.couponId')}
        />
        <SmallInputWrapper>
          <InputItem
            disabled={isFormDisabled}
            label={getTranslationKey('collectionShop.frequency')}
            type="number"
            min={0}
            max={1000}
            value={anniversaryCouponCodeAdvertising?.amountOfImagesBetweenBanners}
            changeCallback={partial(
              updateFormValue,
              'anniversaryCouponCodeAdvertising.amountOfImagesBetweenBanners'
            )}
            id="anniversaryCouponCodeAdvertising-amountOfImagesBetweenBanners"
            withTooltip
            tooltipText={getTranslationKey('collectionShop.frequencyTooltip')}
            tooltipIconPlacement="label"
          />
        </SmallInputWrapper>
      </InlineForm>
    </>
  )
);
